import React from "react";
import { LineChart } from "@mui/x-charts";

interface ReusableLineChartProps {
  data: any[];
  xKey: string;
  xLabel?: string;
  yKeys: string[];
  yKeyAliases?: Record<string, string>; // Optional alias map
  height?: number;
  width?: number;
}

const ReusableLineChart: React.FC<ReusableLineChartProps> = ({
  data,
  xKey,
  xLabel,
  yKeys,
  yKeyAliases = {},
  height = 400,
  width = 700,
}) => {
  const xAxisData = data.map((item) => item[xKey]);

  const series = yKeys.map((yKey) => ({
    data: data.map((item) => item[yKey]),
    label: yKeyAliases[yKey] || yKey, // Use alias if available
    showMark: false,
  }));

  return (
    <LineChart
      height={height}
      width={width}
      xAxis={[{ scaleType: "point", data: xAxisData, label: xLabel || xKey }]}
      series={series}
    />
  );
};

export default ReusableLineChart;
